import React, { useState, useEffect } from 'react';
import { BellRing, ChevronRight } from 'lucide-react';
import { orderAlerts } from '../services/api';

// The order alert list on the dashboard (Greg, Oct 26, 2026: "centralize it also on the
// dashboard"): one strip with the open count and how many ship today, tap to open the
// list. Hidden when nothing is open, and for anyone the list is not for (the server 403s).

export default function OrderAlertsStrip({ navigateTo }) {
  const [c, setC] = useState(null);
  useEffect(() => {
    let live = true;
    const load = () => orderAlerts('board', { view: 'open' })
      .then((r) => { if (live) setC(r.counts); })
      .catch(() => { if (live) setC(null); });
    load();
    const t = setInterval(load, 5 * 60e3);
    return () => { live = false; clearInterval(t); };
  }, []);
  if (!c || !c.open) return null;
  const urgent = c.shipToday > 0 || c.overdue > 0;
  return (
    <button onClick={() => navigateTo('alerts')}
      style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', textAlign: 'left', cursor: 'pointer',
        padding: '10px 14px', marginBottom: 14, borderRadius: 8, fontFamily: 'inherit', fontSize: 14,
        border: 'none', background: urgent ? '#DC582A' : '#00395C', color: '#fff' }}>
      <BellRing size={18} />
      <span style={{ fontWeight: 700 }}>{c.open} open order alert{c.open === 1 ? '' : 's'}</span>
      <span style={{ opacity: 0.9 }}>
        {c.shipToday ? `${c.shipToday} ship${c.shipToday === 1 ? 's' : ''} today` : ''}
        {c.shipToday && c.overdue ? ' · ' : ''}
        {c.overdue ? `${c.overdue} past ship date` : ''}
      </span>
      <ChevronRight size={18} style={{ marginLeft: 'auto' }} />
    </button>
  );
}
